// admin page to see list of hackers for check in, meals, workshops
// button to randomly select waffle winner for a workshop, and mark it in mongo and prevent selecting another winner again
// for the button ^^ should be able to input how many winners to select

const AdminPage = ({ user }) => {
  if (!user?.attributes?.isLeadership) {
    return (
      <div className=''>
        <p className={['text-center text-xl mt-10 text-red-600'].join(' ')}>
          Access denied. You are not leadership.
        </p>
      </div>
    );
  }

  return (
    <div>
      <h1>Admin</h1>
      <p>
        button to randomly select waffle winner for a workshop, and mark it in
        mongo and prevent selecting another winner again
      </p>
    </div>
  );
};

export default AdminPage;
